import CommonZhCN from '@/locales/zh-CN/common';
import ComponentZhCN from '@/locales/zh-CN/component';
import FormZhCN from '@/locales/zh-CN/form';
import GlobalHeaderZhCN from '@/locales/zh-CN/globalHeader';
import MenuZhCN from '@/locales/zh-CN/menu';
import PagesZhCN from '@/locales/zh-CN/pages';
import PwaZhCN from '@/locales/zh-CN/pwa';
import SettingDrawerZhCN from '@/locales/zh-CN/settingDrawer';
import SettingsZhCN from '@/locales/zh-CN/settings';
import PagesSpaceBandLocalesZhCN from '@/pages-pool-member/space/band/locales/zh-CN';

export default {
  ...PagesSpaceBandLocalesZhCN,
  ...CommonZhCN,
  ...ComponentZhCN,
  ...FormZhCN,
  ...GlobalHeaderZhCN,
  ...MenuZhCN,
  ...PagesZhCN,
  ...PwaZhCN,
  ...SettingDrawerZhCN,
  ...SettingsZhCN,
};
